import { render, staticRenderFns } from "./InformedConsentList.vue?vue&type=template&id=2d65804b&"
import script from "./InformedConsentList.vue?vue&type=script&lang=js&"
export * from "./InformedConsentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports